export const RICH_MENU_LIMIT = 4;
